import { render } from "./Documente.vue?vue&type=template&id=33ef3239&scoped=true&ts=true"
import script from "./Documente.ts?vue&type=script&lang=ts"
export * from "./Documente.ts?vue&type=script&lang=ts"

import "./Documente.vue?vue&type=style&index=0&id=33ef3239&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ef3239"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
